import { EMPTY_CRUISE_RECOMMENDATION_ID } from '../constants';

export const getParamsPersonalizationEvent = ({
	enableEventTrackng,
	additionalParamsApplied,
	locale,
	searchSelecting,
	qualifiersSelecting,
	query,
	cruiseRecommendationId,
	brand,
}) => {
	if (enableEventTrackng) {
		const additionalParams = Array.isArray(additionalParamsApplied) ? additionalParamsApplied : additionalParamsApplied?.split('&');

		const additionalData = (Array.isArray(additionalParams) ? additionalParams : [])
			.map((param) => param.split('='))
			.reduce((res, item) => {
				res[item[0]] = item[1];
				return res;
			}, {});

		const data = {
			locale,
			searchApplied: searchSelecting,
			qualifiersApplied: qualifiersSelecting,
			cruiseRecommendationId: cruiseRecommendationId || EMPTY_CRUISE_RECOMMENDATION_ID,
			brand,
		};
		return {
			data,
			query: { ...additionalData, ...query },
		};
	}
	return {};
};
